import { FormFieldInterface } from 'src/api';
import { useTranslation } from 'react-i18next';

type ValidationError = {
    [k: string]: 'requiredError' | 'notValid' | 'genericError';
};

type AgreementFieldProps = {
    field: FormFieldInterface;
    index: number;
    errors: ValidationError;
    onInputChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    openFileViewer?: (url: string) => void,
};

const AgreementField = (props: AgreementFieldProps) => {
    const { field, errors, onInputChange, openFileViewer, index } = props;
    const { t, i18n } = useTranslation();

    const getDocumentName = () => {
        const curLang = i18n.language as 'ru' | 'kz' | 'en';
        switch (curLang) {
            case 'ru':
                return field.labelRu;
            case 'kz':
                return field.labelKz;
            case 'en':
                return field.labelEn;
            default:
                return field.labelRu;
        }
    };

    const getLink = () => {
        const curLang = i18n.language as 'ru' | 'kz' | 'en';
        switch (curLang) {
            case 'ru':
                return field.settings.link;
            case 'kz':
                return field.settings.linkKz;
            case 'en':
                return field.settings.linkEn;
            default:
                return field.settings.link;
        }
    };

    const getOpenLinkContent = () => {
        const link = getLink();
        if (!link || link.trim() === '') {
            return null;
        }

        if (window.VBwidgetConfig.docViewerEnabled) {
            return <button
                className='vb-btn vb-btn-link vb-bcc-link vb-p-0'
                type="button"
                onClick={() => openFileViewer(link)}>
                        ({t('form:agreement:linkLabel')})
            </button>;
        }

        return <a href={link} rel="noreferrer" target="_blank" className='vb-bcc-link'>({t('form:agreement:linkLabel')})</a>;
    };

    return (
        <>
            <div className='vb-form-check'>
                <input
                    id={field.key + index}
                    name={field.key + index}
                    type="checkbox"
                    checked={field.settings.agreementChecked ?? false}
                    className='vb-form-check-input'
                    onChange={(event) => onInputChange(event, index)}
                    required={field.isRequired}
                />
                <label className='vb-form-check-label vb-agreement vb-m-0' htmlFor={field.key + index}>
                    {getDocumentName()}
                    {getOpenLinkContent()}
                </label>
            </div>
            {errors[field.key + index] && (
                <div
                    className='vb-ms-3 vb-mt-1 vb-text-danger'>
                    {t(
                        `form:${field.key}:${
                            errors[field.key + index]
                        }`,
                    )}
                </div>
            )}
        </>
    );
};
export default AgreementField;
